import React from 'react'

const AutomationsBlockGridBg = ({ className }) => (
  <svg
    width="1440"
    height="1421"
    viewBox="0 0 1440 1421"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g opacity="0.08">
      <line x1="4.37114e-08" y1="21.5" x2="1440" y2="21.5001" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="99.5" x2="1440" y2="99.5001" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="177.5" x2="1440" y2="177.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="255.5" x2="1440" y2="255.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="333.5" x2="1440" y2="333.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="411.5" x2="1440" y2="411.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="463.5" x2="1440" y2="463.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="47.5" x2="1440" y2="47.5001" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="125.5" x2="1440" y2="125.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="203.5" x2="1440" y2="203.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="281.5" x2="1440" y2="281.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="359.5" x2="1440" y2="359.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="437.5" x2="1440" y2="437.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="73.5" x2="1440" y2="73.5001" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="151.5" x2="1440" y2="151.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="229.5" x2="1440" y2="229.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="307.5" x2="1440" y2="307.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="385.5" x2="1440" y2="385.5" stroke="#BABABA" />
      <line x1="502.5" y1="489" x2="502.5" y2="0.999969" stroke="#BABABA" />
      <line x1="580.5" y1="489" x2="580.5" y2="0.999969" stroke="#BABABA" />
      <line x1="658.5" y1="489" x2="658.5" y2="0.999969" stroke="#BABABA" />
      <line x1="736.5" y1="489" x2="736.5" y2="0.999969" stroke="#BABABA" />
      <line x1="814.5" y1="489" x2="814.5" y2="0.999969" stroke="#BABABA" />
      <line x1="892.5" y1="489" x2="892.5" y2="0.999969" stroke="#BABABA" />
      <line x1="528.5" y1="489" x2="528.5" y2="0.999969" stroke="#BABABA" />
      <line x1="606.5" y1="489" x2="606.5" y2="0.999969" stroke="#BABABA" />
      <line x1="684.5" y1="489" x2="684.5" y2="0.999969" stroke="#BABABA" />
      <line x1="762.5" y1="489" x2="762.5" y2="0.999969" stroke="#BABABA" />
      <line x1="840.5" y1="489" x2="840.5" y2="0.999969" stroke="#BABABA" />
      <line x1="918.5" y1="489" x2="918.5" y2="0.999969" stroke="#BABABA" />
      <line x1="554.5" y1="489" x2="554.5" y2="0.999969" stroke="#BABABA" />
      <line x1="632.5" y1="489" x2="632.5" y2="0.999969" stroke="#BABABA" />
      <line x1="710.5" y1="489" x2="710.5" y2="0.999969" stroke="#BABABA" />
      <line x1="788.5" y1="489" x2="788.5" y2="0.999969" stroke="#BABABA" />
      <line x1="866.5" y1="489" x2="866.5" y2="0.999969" stroke="#BABABA" />
      <line x1="944.5" y1="489" x2="944.5" y2="0.999969" stroke="#BABABA" />
      <line x1="37.5" y1="489" x2="37.5" y2="0.999969" stroke="#BABABA" />
      <line x1="115.5" y1="489" x2="115.5" y2="0.999969" stroke="#BABABA" />
      <line x1="193.5" y1="489" x2="193.5" y2="0.999969" stroke="#BABABA" />
      <line x1="271.5" y1="489" x2="271.5" y2="0.999969" stroke="#BABABA" />
      <line x1="349.5" y1="489" x2="349.5" y2="0.999969" stroke="#BABABA" />
      <line x1="427.5" y1="489" x2="427.5" y2="0.999969" stroke="#BABABA" />
      <line x1="63.5" y1="489" x2="63.5" y2="0.999969" stroke="#BABABA" />
      <line x1="141.5" y1="489" x2="141.5" y2="0.999969" stroke="#BABABA" />
      <line x1="219.5" y1="489" x2="219.5" y2="0.999969" stroke="#BABABA" />
      <line x1="297.5" y1="489" x2="297.5" y2="0.999969" stroke="#BABABA" />
      <line x1="375.5" y1="489" x2="375.5" y2="0.999969" stroke="#BABABA" />
      <line x1="453.5" y1="489" x2="453.5" y2="0.999969" stroke="#BABABA" />
      <line x1="89.5" y1="489" x2="89.5" y2="0.999969" stroke="#BABABA" />
      <line x1="167.5" y1="489" x2="167.5" y2="0.999969" stroke="#BABABA" />
      <line x1="245.5" y1="489" x2="245.5" y2="0.999969" stroke="#BABABA" />
      <line x1="323.5" y1="489" x2="323.5" y2="0.999969" stroke="#BABABA" />
      <line x1="401.5" y1="489" x2="401.5" y2="0.999969" stroke="#BABABA" />
      <line x1="479.5" y1="489" x2="479.5" y2="0.999969" stroke="#BABABA" />
      <line x1="969.5" y1="489" x2="969.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1047.5" y1="489" x2="1047.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1125.5" y1="489" x2="1125.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1203.5" y1="489" x2="1203.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1281.5" y1="489" x2="1281.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1359.5" y1="489" x2="1359.5" y2="0.999939" stroke="#BABABA" />
      <line x1="995.5" y1="489" x2="995.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1073.5" y1="489" x2="1073.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1151.5" y1="489" x2="1151.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1229.5" y1="489" x2="1229.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1307.5" y1="489" x2="1307.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1385.5" y1="489" x2="1385.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1021.5" y1="489" x2="1021.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1099.5" y1="489" x2="1099.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1177.5" y1="489" x2="1177.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1255.5" y1="489" x2="1255.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1333.5" y1="489" x2="1333.5" y2="0.999939" stroke="#BABABA" />
      <line x1="1411.5" y1="489" x2="1411.5" y2="0.999939" stroke="#BABABA" />
    </g>
    <g opacity="0.08">
      <line x1="4.37114e-08" y1="489.5" x2="1440" y2="489.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="567.5" x2="1440" y2="567.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="645.5" x2="1440" y2="645.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="723.5" x2="1440" y2="723.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="801.5" x2="1440" y2="801.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="879.5" x2="1440" y2="879.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="515.5" x2="1440" y2="515.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="593.5" x2="1440" y2="593.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="671.5" x2="1440" y2="671.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="749.5" x2="1440" y2="749.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="827.5" x2="1440" y2="827.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="905.5" x2="1440" y2="905.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="931.5" x2="1440" y2="931.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="541.5" x2="1440" y2="541.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="619.5" x2="1440" y2="619.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="697.5" x2="1440" y2="697.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="775.5" x2="1440" y2="775.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="853.5" x2="1440" y2="853.5" stroke="#BABABA" />
      <line x1="502.5" y1="953.173" x2="502.5" y2="490.001" stroke="#BABABA" />
      <line x1="580.5" y1="953.173" x2="580.5" y2="490.001" stroke="#BABABA" />
      <line x1="658.5" y1="953.173" x2="658.5" y2="490.001" stroke="#BABABA" />
      <line x1="736.5" y1="953.173" x2="736.5" y2="490.001" stroke="#BABABA" />
      <line x1="814.5" y1="953.173" x2="814.5" y2="490.001" stroke="#BABABA" />
      <line x1="892.5" y1="953.173" x2="892.5" y2="490.001" stroke="#BABABA" />
      <line x1="528.5" y1="953.173" x2="528.5" y2="490.001" stroke="#BABABA" />
      <line x1="606.5" y1="953.173" x2="606.5" y2="490.001" stroke="#BABABA" />
      <line x1="684.5" y1="953.173" x2="684.5" y2="490.001" stroke="#BABABA" />
      <line x1="762.5" y1="953.173" x2="762.5" y2="490.001" stroke="#BABABA" />
      <line x1="840.5" y1="953.173" x2="840.5" y2="490.001" stroke="#BABABA" />
      <line x1="918.5" y1="953.173" x2="918.5" y2="490.001" stroke="#BABABA" />
      <line x1="554.5" y1="953.173" x2="554.5" y2="490.001" stroke="#BABABA" />
      <line x1="632.5" y1="953.173" x2="632.5" y2="490.001" stroke="#BABABA" />
      <line x1="710.5" y1="953.173" x2="710.5" y2="490.001" stroke="#BABABA" />
      <line x1="788.5" y1="953.173" x2="788.5" y2="490.001" stroke="#BABABA" />
      <line x1="866.5" y1="953.173" x2="866.5" y2="490.001" stroke="#BABABA" />
      <line x1="944.5" y1="953.173" x2="944.5" y2="490.001" stroke="#BABABA" />
      <line x1="37.5" y1="953.173" x2="37.5" y2="490.001" stroke="#BABABA" />
      <line x1="115.5" y1="953.173" x2="115.5" y2="490.001" stroke="#BABABA" />
      <line x1="193.5" y1="953.173" x2="193.5" y2="490.001" stroke="#BABABA" />
      <line x1="271.5" y1="953.173" x2="271.5" y2="490.001" stroke="#BABABA" />
      <line x1="349.5" y1="953.173" x2="349.5" y2="490.001" stroke="#BABABA" />
      <line x1="427.5" y1="953.173" x2="427.5" y2="490.001" stroke="#BABABA" />
      <line x1="63.5" y1="953.173" x2="63.5" y2="490.001" stroke="#BABABA" />
      <line x1="141.5" y1="953.173" x2="141.5" y2="490.001" stroke="#BABABA" />
      <line x1="219.5" y1="953.173" x2="219.5" y2="490.001" stroke="#BABABA" />
      <line x1="297.5" y1="953.173" x2="297.5" y2="490.001" stroke="#BABABA" />
      <line x1="375.5" y1="953.173" x2="375.5" y2="490.001" stroke="#BABABA" />
      <line x1="453.5" y1="953.173" x2="453.5" y2="490.001" stroke="#BABABA" />
      <line x1="89.5" y1="953.173" x2="89.5" y2="490.001" stroke="#BABABA" />
      <line x1="167.5" y1="953.173" x2="167.5" y2="490.001" stroke="#BABABA" />
      <line x1="245.5" y1="953.173" x2="245.5" y2="490.001" stroke="#BABABA" />
      <line x1="323.5" y1="953.173" x2="323.5" y2="490.001" stroke="#BABABA" />
      <line x1="401.5" y1="953.173" x2="401.5" y2="490.001" stroke="#BABABA" />
      <line x1="479.5" y1="953.173" x2="479.5" y2="490.001" stroke="#BABABA" />
      <line x1="969.5" y1="957" x2="969.5" y2="490" stroke="#BABABA" />
      <line x1="1047.5" y1="957" x2="1047.5" y2="490" stroke="#BABABA" />
      <line x1="1125.5" y1="957" x2="1125.5" y2="490" stroke="#BABABA" />
      <line x1="1203.5" y1="957" x2="1203.5" y2="490" stroke="#BABABA" />
      <line x1="1281.5" y1="957" x2="1281.5" y2="490" stroke="#BABABA" />
      <line x1="1359.5" y1="957" x2="1359.5" y2="490" stroke="#BABABA" />
      <line x1="995.5" y1="957" x2="995.5" y2="490" stroke="#BABABA" />
      <line x1="1073.5" y1="957" x2="1073.5" y2="490" stroke="#BABABA" />
      <line x1="1151.5" y1="957" x2="1151.5" y2="490" stroke="#BABABA" />
      <line x1="1229.5" y1="957" x2="1229.5" y2="490" stroke="#BABABA" />
      <line x1="1307.5" y1="957" x2="1307.5" y2="490" stroke="#BABABA" />
      <line x1="1385.5" y1="957" x2="1385.5" y2="490" stroke="#BABABA" />
      <line x1="1021.5" y1="957" x2="1021.5" y2="490" stroke="#BABABA" />
      <line x1="1099.5" y1="957" x2="1099.5" y2="490" stroke="#BABABA" />
      <line x1="1177.5" y1="957" x2="1177.5" y2="490" stroke="#BABABA" />
      <line x1="1255.5" y1="957" x2="1255.5" y2="490" stroke="#BABABA" />
      <line x1="1333.5" y1="957" x2="1333.5" y2="490" stroke="#BABABA" />
      <line x1="1411.5" y1="957" x2="1411.5" y2="490" stroke="#BABABA" />
    </g>
    <g opacity="0.08">
      <line x1="4.37114e-08" y1="957.5" x2="1440" y2="957.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1035.5" x2="1440" y2="1035.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1113.5" x2="1440" y2="1113.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1191.5" x2="1440" y2="1191.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1269.5" x2="1440" y2="1269.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1347.5" x2="1440" y2="1347.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="983.5" x2="1440" y2="983.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1061.5" x2="1440" y2="1061.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1139.5" x2="1440" y2="1139.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1217.5" x2="1440" y2="1217.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1295.5" x2="1440" y2="1295.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1373.5" x2="1440" y2="1373.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1009.5" x2="1440" y2="1009.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1087.5" x2="1440" y2="1087.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1165.5" x2="1440" y2="1165.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1243.5" x2="1440" y2="1243.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1321.5" x2="1440" y2="1321.5" stroke="#BABABA" />
      <line x1="4.37114e-08" y1="1399.5" x2="1440" y2="1399.5" stroke="#BABABA" />
      <line x1="502.5" y1="1421" x2="502.5" y2="953" stroke="#BABABA" />
      <line x1="580.5" y1="1421" x2="580.5" y2="953" stroke="#BABABA" />
      <line x1="658.5" y1="1421" x2="658.5" y2="953" stroke="#BABABA" />
      <line x1="736.5" y1="1421" x2="736.5" y2="953" stroke="#BABABA" />
      <line x1="814.5" y1="1421" x2="814.5" y2="953" stroke="#BABABA" />
      <line x1="892.5" y1="1421" x2="892.5" y2="953" stroke="#BABABA" />
      <line x1="528.5" y1="1421" x2="528.5" y2="953" stroke="#BABABA" />
      <line x1="606.5" y1="1421" x2="606.5" y2="953" stroke="#BABABA" />
      <line x1="684.5" y1="1421" x2="684.5" y2="953" stroke="#BABABA" />
      <line x1="762.5" y1="1421" x2="762.5" y2="953" stroke="#BABABA" />
      <line x1="840.5" y1="1421" x2="840.5" y2="953" stroke="#BABABA" />
      <line x1="918.5" y1="1421" x2="918.5" y2="953" stroke="#BABABA" />
      <line x1="554.5" y1="1421" x2="554.5" y2="953" stroke="#BABABA" />
      <line x1="632.5" y1="1421" x2="632.5" y2="953" stroke="#BABABA" />
      <line x1="710.5" y1="1421" x2="710.5" y2="953" stroke="#BABABA" />
      <line x1="788.5" y1="1421" x2="788.5" y2="953" stroke="#BABABA" />
      <line x1="866.5" y1="1421" x2="866.5" y2="953" stroke="#BABABA" />
      <line x1="944.5" y1="1421" x2="944.5" y2="953" stroke="#BABABA" />
      <line x1="37.5" y1="1421" x2="37.5" y2="953" stroke="#BABABA" />
      <line x1="115.5" y1="1421" x2="115.5" y2="953" stroke="#BABABA" />
      <line x1="193.5" y1="1421" x2="193.5" y2="953" stroke="#BABABA" />
      <line x1="271.5" y1="1421" x2="271.5" y2="953" stroke="#BABABA" />
      <line x1="349.5" y1="1421" x2="349.5" y2="953" stroke="#BABABA" />
      <line x1="427.5" y1="1421" x2="427.5" y2="953" stroke="#BABABA" />
      <line x1="63.5" y1="1421" x2="63.5" y2="953" stroke="#BABABA" />
      <line x1="141.5" y1="1421" x2="141.5" y2="953" stroke="#BABABA" />
      <line x1="219.5" y1="1421" x2="219.5" y2="953" stroke="#BABABA" />
      <line x1="297.5" y1="1421" x2="297.5" y2="953" stroke="#BABABA" />
      <line x1="375.5" y1="1421" x2="375.5" y2="953" stroke="#BABABA" />
      <line x1="453.5" y1="1421" x2="453.5" y2="953" stroke="#BABABA" />
      <line x1="89.5" y1="1421" x2="89.5" y2="953" stroke="#BABABA" />
      <line x1="167.5" y1="1421" x2="167.5" y2="953" stroke="#BABABA" />
      <line x1="245.5" y1="1421" x2="245.5" y2="953" stroke="#BABABA" />
      <line x1="323.5" y1="1421" x2="323.5" y2="953" stroke="#BABABA" />
      <line x1="401.5" y1="1421" x2="401.5" y2="953" stroke="#BABABA" />
      <line x1="479.5" y1="1421" x2="479.5" y2="953" stroke="#BABABA" />
      <line x1="969.5" y1="1421" x2="969.5" y2="958" stroke="#BABABA" />
      <line x1="1047.5" y1="1421" x2="1047.5" y2="958" stroke="#BABABA" />
      <line x1="1125.5" y1="1421" x2="1125.5" y2="958" stroke="#BABABA" />
      <line x1="1203.5" y1="1421" x2="1203.5" y2="958" stroke="#BABABA" />
      <line x1="1281.5" y1="1421" x2="1281.5" y2="958" stroke="#BABABA" />
      <line x1="1359.5" y1="1421" x2="1359.5" y2="958" stroke="#BABABA" />
      <line x1="995.5" y1="1421" x2="995.5" y2="958" stroke="#BABABA" />
      <line x1="1073.5" y1="1421" x2="1073.5" y2="958" stroke="#BABABA" />
      <line x1="1151.5" y1="1421" x2="1151.5" y2="958" stroke="#BABABA" />
      <line x1="1229.5" y1="1421" x2="1229.5" y2="958" stroke="#BABABA" />
      <line x1="1307.5" y1="1421" x2="1307.5" y2="958" stroke="#BABABA" />
      <line x1="1385.5" y1="1421" x2="1385.5" y2="958" stroke="#BABABA" />
      <line x1="1021.5" y1="1421" x2="1021.5" y2="958" stroke="#BABABA" />
      <line x1="1099.5" y1="1421" x2="1099.5" y2="958" stroke="#BABABA" />
      <line x1="1177.5" y1="1421" x2="1177.5" y2="958" stroke="#BABABA" />
      <line x1="1255.5" y1="1421" x2="1255.5" y2="958" stroke="#BABABA" />
      <line x1="1333.5" y1="1421" x2="1333.5" y2="958" stroke="#BABABA" />
      <line x1="1411.5" y1="1421" x2="1411.5" y2="958" stroke="#BABABA" />
    </g>
    <rect y="1348" width="1440" height="73" fill="url(#paint0_linear_5881_1066)" />
    <rect x="3" width="1437" height="100" fill="url(#paint1_linear_5881_1066)" />
    <defs>
      <linearGradient id="paint0_linear_5881_1066" x1="720.498" y1="1421" x2="720.498" y2="1348" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="paint1_linear_5881_1066" x1="721.997" y1="100" x2="721.997" y2="-5.64971e-06" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.54" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
)

export default AutomationsBlockGridBg
